import React, { useState } from "react";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,   FirstAds,MobileUnderCalAds } from "../../Ads";
import SharedHelmet from "../Helmet";
const TITLE = "Body Type Calculator";
const DESCRIPTION =
  "A body type calculator helps you determine your body type based on your bust, waist, high hip, and hip measurements. This can provide insights into your body shape.";
const KEYWORDS =
  "body type calculator, body shape, bust size, waist size, hip size, high hip size";
const OG_URL = "https://do-calculate.com/calculator/en/body-type-calculator/";
function BodyTypeCalculator() {
  const [bust, setBust] = useState("");
  const [waist, setWaist] = useState("");
  const [highHip, setHighHip] = useState("");
  const [hip, setHip] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);
  const handleBustChange = (event) => {
    setBust(event.target.value);
  };
  const handleWaistChange = (event) => {
    setWaist(event.target.value);
  };
  const handleHighHipChange = (event) => {
    setHighHip(event.target.value);
  };
  const handleHipChange = (event) => {
    setHip(event.target.value);
  };
  const calculateBodyType = () => {
    const bustNum = parseFloat(bust);
    const waistNum = parseFloat(waist);
    const highHipNum = parseFloat(highHip);
    const hipNum = parseFloat(hip);
    if (
      isNaN(bustNum) ||
      isNaN(waistNum) ||
      isNaN(highHipNum) ||
      isNaN(hipNum) ||
      bustNum <= 0 ||
      waistNum <= 0 ||
      highHipNum <= 0 ||
      hipNum <= 0
    ) {
      setError("Enter valid inputs");
      setResult(null);
      return;
    }
    let bodyType = "Unknown";
    if (bustNum === hipNum && waistNum < bustNum) {
      bodyType = "Hourglass";
    } else if (hipNum > bustNum && waistNum < hipNum) {
      bodyType = "Pear";
    } else if (bustNum > hipNum && waistNum < bustNum) {
      bodyType = "Inverted Triangle";
    } else if (bustNum === waistNum && waistNum === hipNum) {
      bodyType = "Rectangle";
    } else {
      bodyType = "Apple";
    }
    setResult(bodyType);
    setError(null);
  };
  return (
    <div className="ltr">
        <SharedHelmet
             TITLE={TITLE}
             DESCRIPTION={DESCRIPTION}
             KEYWORDS={KEYWORDS}
             OG_URL={OG_URL}
           />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "39px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  A body type calculator helps you determine your body type
                  based on your bust, waist, high hip, and hip measurements.
                  This can provide insights into your body shape and help you
                  understand how to dress for your body type.
                </p>
                <img
                  src="/Women body types.jpg"
                  alt="Sizing illustration"
                  style={{ width: "100%" }}
                />
                <hr />
              </div>
            </div>
            <div className="row">
              <div className="col-12 col-md-5 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  Body Type Calculator
                </div>
                <hr />
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="bust" className="form-label ms-2">
                      Bust Size
                    </label>
                  </b>
                  <input
                    type="number"
                    id="bust"
                    value={bust}
                    onChange={handleBustChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="inches"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="waist" className="form-label ms-2">
                      Waist Size
                    </label>
                  </b>
                  <input
                    type="number"
                    id="waist"
                    value={waist}
                    onChange={handleWaistChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="inches"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="highHip" className="form-label ms-2">
                      High Hip Size
                    </label>
                  </b>
                  <input
                    type="number"
                    id="highHip"
                    value={highHip}
                    onChange={handleHighHipChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="inches"
                  />
                </div>
                <br />
                <div className="form-group d-flex align-items-center">
                  <b>
                    <label htmlFor="hip" className="form-label ms-2">
                      Hip Size
                    </label>
                  </b>
                  <input
                    type="number"
                    id="hip"
                    value={hip}
                    onChange={handleHipChange}
                    className="form-control ml-2"
                    style={{ width: "90%" }}
                    placeholder="inches"
                  />
                </div>
                <br />
                <hr />
                <div>
                  <button
                    className="btn btn-success"
                    style={{ fontSize: "20px" }}
                    onClick={calculateBodyType}
                  >
                    Calculate                  </button>
                </div>
              </div>
              <div className="col-12 col-md-7">
                <div>
                  { error && (
                    <div className="alert alert-warning">
                      <b>
                        <u>An error occured:</u>
                      </b>{" "}
                      {error}
                    </div>
                  )}
                  { result && (
                    <div>
                      <h4>Result:</h4>
                      <hr />
                      <div
                        style={{
                          backgroundColor: "#D1E7DD",
                          borderColor: "#c3e6cb",
                          color: "#155724",
                          padding: "15px",
                          marginBottom: "20px",
                          borderRadius: "4px",
                        }}
                      >
                        <p>Your body type is: {result}</p>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br/>        </div>
      </div>
      <hr />
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                How to use the body type calculator?
              </div>
              <div className="info-section-body">
                <p>
                  To use the body type calculator, enter your bust, waist, high
                  hip, and hip measurements. Click the "Calculate" button to get
                  your body type.
                </p>
              </div>
            </div>
          </div>
          <br />
          <u>
            <h2>Frequently Asked Questions</h2>
          </u>
          <br />
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  What is a body type calculator?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  A body type calculator helps you determine your body type
                  based on your bust, waist, high hip, and hip measurements.
                  This can provide insights into your body shape.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Why is it important to know your body type?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Knowing your body type can help you choose clothing that
                  flatters your figure and highlights your best features. It can
                  also help you understand your body's natural tendencies and
                  how to maintain a healthy lifestyle.
                </p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  What are the different body types?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  The main body types are Hourglass, Pear, Inverted Triangle,
                  Rectangle, and Apple. Each body type has unique
                  characteristics and understanding them can help in choosing
                  the right clothing and fitness plans.
                </p>
                <img
                  src="path_to_body_shapes_image.jpg"
                  alt="Different body shapes"
                  style={{ width: "100%" }}
                />
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header">
                <h3 style={{ fontSize: "16px" }}>
                  Can my body type change over time?
                </h3>
              </div>
              <div className="info-section-body">
                <p>
                  Yes, your body type can change over time due to factors such
                  as aging, weight gain or loss, and changes in muscle mass.
                  Maintaining a healthy lifestyle can help you manage these
                  changes effectively.
                </p>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default BodyTypeCalculator;
